const Footer = () => {
    return ( 
        <>
         <footer class="footer_div">
            <div class="footer_position">
               <div class="footer_position_flex">
                  <div class="footer_position_inner">
                     <div class="footer_position_inner_left">
                        <h3>
                           <em>JOIN</em>&nbsp;UNIVERSAL <br/>SPACE STATION
                        </h3>
                        <div class="footer_btn_flex">
                           <div class="footer_btn_inner">
                              <a target="_blank" href="https://discord.gg/46UEWpPQkt" class="btn"> <img src="images/btn_img2.png" title="" alt=""/> <span>DISCORD</span></a>
                           </div>
                           <div class="footer_btn_inner">
                              <a href="https://opensea.io/collection/uss-crypto-pilots" class="btn btn2" target="_blank"> <img src="images/btn_img4.png" title="" alt=""/> <span>OPEN SEA</span></a>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="footer_position_inner hidden-xs">
                     <div class="footer_position_logo">  
                        <div class="footer_position_inner_right">
                           <h3>
                              <em>FOLLOW</em> US
                           </h3>
                           <div class="footer_position_inner_ticket">  
                              {/* <a href="https://www.facebook.com/CryptoPilots" target="_blank"><i class="fa fa-facebook" target="_blank"></i></a> */}
                              <a href="https://www.instagram.com/cryptopilots_uss/" target="_blank"><i class="fa fa-instagram"></i></a>
                              <a href="https://twitter.com/Uss_Cryptopilot" target="_blank"><i class="fa fa-twitter"></i></a>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="footer_position_inner">
                     <div class="footer_position_inner_right">
                        <h3>
                           <em>MINT Date</em> <br/>
                           TBD 
                        </h3>
                        <div class="footer_position_inner_ticket">  
                           <a href="https://opensea.io/collection/uss-crypto-pilots" class="btn" target="_blank">Buy On Opensea</a>
                        </div>
                     </div>
                  </div>
                  <div class="footer_position_inner visible-xs">
                     <div class="footer_position_logo">  
                        <div class="footer_position_inner_right">
                           <h3>
                              <em>FOLLOW</em> US
                           </h3>
                           <div class="footer_position_inner_ticket">  
                              {/* <a href="https://www.facebook.com/CryptoPilots" target="_blank"><i class="fa fa-facebook" target="_blank"></i></a> */}
                              <a href="https://www.instagram.com/cryptopilots_uss/" target="_blank"><i class="fa fa-instagram"></i></a>
                              <a href="https://twitter.com/Uss_Cryptopilot" target="_blank"><i class="fa fa-twitter"></i></a>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="footer_bottom_flex">
                  <div class="footer_bottom_inner">
                     <h6>© 2022 UNIVERSAL SPACE STATION. ALL RIGHTS RESERVED</h6>
                  </div>
               </div>
            </div>
      </footer>
        </>
     );
}
 
export default Footer;